import { EpicRefined } from 'interfaces/middleware'
import { VideoCallAction, UpdateMediaPermissionsAction } from 'components/features/videoCalls/types/actions'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { getPermissions } from 'components/features/videoCalls/helpers'


export const permissionsEpic: EpicRefined<VideoCallAction> = (action$) => action$.pipe(
  filterRequestOfType(UpdateMediaPermissionsAction.type, 'request'),
  mergeMapAsync(async (action) => {
    const {
      cameraPermissions,
      microphonePermissions,
    } = await getPermissions()

    return action.success({
      cam: cameraPermissions,
      mic: microphonePermissions,
    })
  }),
)
